module.exports = __webpack_public_path__ + "799a5dfe19dadb7adb1fad6361f7b479.jpg";